export const dialogs = {
	NON_UNIQUE_OR_NON_EXISTANT_USER: 'NON_UNIQUE_OR_NON_EXISTANT_USER',
};
